import { BurnNonSensitiveUi } from "firefly-shared-ts-domain";
import { useMemo } from "react";

export const useBurnColors = (
  burns: Array<BurnNonSensitiveUi> | undefined
): string[] | undefined => {
  return useMemo(() => burns?.map((it) => it.color), [burns]);
};
